const en = {
    arrow_instruction: 'Swipe right and left to see new opportunities',
    job_offer_instruction: 'View job offer details',
    decline_offer_instruction: 'Decline the job offer',
    share_offer_instruction: 'Share the offer with your contacts',
    apply_offer_instruction: 'If you want to apply, click here',
    save_offer_instruction: 'Save the offer to apply later',
};
export default en;
